import { render, staticRenderFns } from "./StatisticsTemplates.vue?vue&type=template&id=2581d051"
import script from "./StatisticsTemplates.vue?vue&type=script&lang=js"
export * from "./StatisticsTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports